import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    fetch("/lottie-404.json")
      .then((res) => res.json())
      .then(setAnimationData)
      .catch(() => {});
  }, []);

  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{ background: "#1f2224" }}
    >
      <div className="w-full max-w-md">
        {animationData && (
          <Lottie
            animationData={animationData}
            loop
            autoplay
            style={{ width: "100%", maxHeight: 320 }}
            data-testid="not-found-lottie"
          />
        )}
      </div>

      <h1
        className="mt-6 text-3xl sm:text-4xl font-bold tracking-tight text-white text-center"
        data-testid="not-found-title"
      >
        Sayfa Bulunamadı
      </h1>
      <p
        className="mt-3 text-base text-gray-400 text-center max-w-sm"
        data-testid="not-found-description"
      >
        Aradığınız sayfa mevcut değil veya taşınmış olabilir.
      </p>

      <div className="mt-8 flex gap-3">
        <button
          data-testid="not-found-go-back"
          onClick={() => navigate(-1)}
          className="px-5 py-2.5 rounded-lg text-sm font-medium text-white border border-gray-600 hover:border-gray-400 transition-colors"
        >
          Geri Dön
        </button>
        <button
          data-testid="not-found-go-home"
          onClick={() => navigate("/")}
          className="px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-500 transition-colors"
        >
          Ana Sayfa
        </button>
      </div>
    </div>
  );
}
